import React from 'react';
import { Create, SimpleForm, TextInput, BooleanInput } from 'react-admin';
import Autocomplete from '../../fields/Autocomplete';

const NotificationCreate = props => (
  <Create {...props}>
    <SimpleForm redirect="/notifications">
      <TextInput source="message" />
      <TextInput source="url" />
      <BooleanInput label="Open in a new window" source="blank" defaultValue />
      <Autocomplete source="user_ids" label="Users" />
    </SimpleForm>
  </Create>
);

export default NotificationCreate;



// WEBPACK FOOTER //
// ./src/resources/notifications/NotificationCreate.jsx